export default "__VITE_ASSET__Cd6XzDQj__"